/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

import { PlatformMessage } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

/**
 * Successful result of `getScreenshot`
 */
export interface ScreenshotPromiseSuccess {
    /** Base64 encoded JPEG image */
    base64Image: string;

    mimeType?: 'image/jpeg';
}

/**
 * Failed result of `getScreenshot`
 */
export interface ScreenshotPromiseFailure {
    error: {
        message: string;
        name?: string;
    };
    result: unknown;
}

export interface ScreenshotInterface {
    /**
     * **Feature:** Get screenshot of the player.
     *
     * @throws {@link ScreenshotPromiseFailure}
     */
    getScreenshot(): Promise<ScreenshotPromiseSuccess>;
}

export function supportsScreenshot(platform: unknown): platform is ScreenshotInterface {
    if (platform instanceof PlayerPmc) {
        return platform.supportsMessage(PlatformMessage.ScreenshotGet);
    }

    return platform instanceof Object && 'getScreenshot' in platform;
}
